import { registerUtils } from '../application/nm'
import { create as makeEmptyObj } from './object'

export const MEDIA_QUERIES = {
  MOBILE: '(min-width: 320px) and (max-width: 767px)',
  TABLET: '(min-width: 768px) and (max-width: 1023px)',
  DESKTOP: '(min-width: 1024px) and (max-width: 1311px)',
  DESKTOP_WIDE: '(min-width: 1312px)',
}

export function getMobileQuery() {
  return window.matchMedia(MEDIA_QUERIES.MOBILE)
}

export function getTabletQuery() {
  return window.matchMedia(MEDIA_QUERIES.TABLET)
}

export function getDesktopQuery() {
  return window.matchMedia(MEDIA_QUERIES.DESKTOP)
}

export function getDesktopWideQuery() {
  return window.matchMedia(MEDIA_QUERIES.DESKTOP_WIDE)
}

const mediaQueryUtils = Object.assign(makeEmptyObj(), {
  getMobileQuery,
  getTabletQuery,
  getDesktopQuery,
  getDesktopWideQuery,
  MEDIA_QUERIES,
})

registerUtils({ mediaQueryUtils })



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/mediaQuery.js